/**
 * Search that forgives Arabic spelling: أ إ آ ا are one letter, ة = ه, ى = ي, ؤ ئ = و ي,
 * tashkeel and tatweel are ignored, Arabic-Indic digits match Latin ones. Case-insensitive.
 */
export function normalize(s: string | null | undefined): string {
  return (s ?? '')
    .toLowerCase()
    .replace(/[ً-ٰٟـ]/g, '') // tashkeel + tatweel
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/\s+/g, ' ')
    .trim();
}

/** Every word of the query appears in one of the texts (any order). */
export function matches(query: string, ...texts: (string | null | undefined)[]): boolean {
  const q = normalize(query);
  if (!q) return true;
  const hay = normalize(texts.filter(Boolean).join(' '));
  // the article "ال" is optional: "شقه" finds "الشقة"
  return q.split(' ').every((w) => hay.includes(w) || (w.startsWith('ال') && hay.includes(w.slice(2))));
}

/** MUI Autocomplete filterOptions with the same rules. */
export const arabicFilter =
  <T,>(text: (o: T) => string | (string | null | undefined)[]) =>
  (options: T[], { inputValue }: { inputValue: string }) =>
    options.filter((o) => {
      const t = text(o);
      return matches(inputValue, ...(Array.isArray(t) ? t : [t]));
    });
